import React from 'react';
import Header from '../components/Header';
import CinematicHero from '../components/CinematicHero';
import DataAdvantage from '../components/DataAdvantage';
import UseCases from '../components/UseCases';
import StatsSection from '../components/StatsSection';
import { WhatYouGet, RequestBand } from '../components/HomeSections';
import { BenchmarksSummary } from '../components/BenchmarksSummary';
import Footer from '../components/Footer';

const MONTAGE_URL = "https://customer-assets-jt897jd0.emergentagent.net/job_55a8b9b9-15d0-4863-a1a9-845a4c0ca70f/artifacts/k5vbkf0p_website_montage_v5.mp4";

const LandingPage = () => (
  <div className="min-h-screen bg-[#0A0A0A] text-white">
    <Header />
    <main>
      <CinematicHero videoUrl={MONTAGE_URL} />
      <div className="relative z-10 bg-[#0A0A0A]">
        <DataAdvantage />
        <WhatYouGet />
        <BenchmarksSummary />
        <UseCases />
        <StatsSection />
        <RequestBand />
        <Footer />
      </div>
    </main>
  </div>
);

export default LandingPage;
